import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ContentContainer } from "./ContentContainer";
import { ListItemText } from "./ListItemText";

export function Content3() {
  return (
    <ContentContainer backgroundColor="secondary">
      <Registration />
      <Visits />
      <Education />
    </ContentContainer>
  );
}

function Registration() {
  return (
    <>
      <Typography variant="h2" fontWeight={"medium"}>
        Rejestracja
      </Typography>
      <Typography variant="h3" fontWeight={"medium"}>
        Rejestracja telefoniczna
      </Typography>
      <Typography>
        <Typography component={"span"} fontWeight={"medium"}>
          tel. 53 63 72 339
        </Typography>{" "}
        (od poniedziałku do piątku w godzinach od 10 do 15)
      </Typography>
      <Typography variant="h3" fontWeight={"medium"}>
        Rejestracja poprzez mail
      </Typography>
      <Typography fontWeight={"medium"}>
        neurologopeda.przemysl@gmail.com
      </Typography>
    </>
  );
}

function Visits() {
  const commonSx = { fontWeight: "medium" } as const;
  return (
    <Stack>
      <Typography variant="h2" sx={commonSx}>
        Wizyty
      </Typography>
      <List>
        <ListItem>
          <ListItemText sx={commonSx}>w gabinecie w Przemyślu,</ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={commonSx}>
            w domu pacjenta (Przemyśl i okolice oraz Sanok i okolice),
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText sx={commonSx}>
            konsultacje online (jako kontynuacja terapii).
          </ListItemText>
        </ListItem>
      </List>
    </Stack>
  );
}

function Education() {
  return (
    <Typography>
      <Typography component={"span"} fontWeight={"medium"}>
        mgr Ewa Czekańska – logopeda, neurologopeda, terapeuta miofunkcjonalny.
      </Typography>{" "}
      Absolwentka Akademii Medycznej w Poznaniu, Uniwersytetu Marii
      Curie-Skłodowskiej w Lublinie (studia logopedyczne) oraz Uniwersytetu
      Rzeszowskiego (studia podyplomowe w zakresie neurologopedii).
      Certyfikowany terapeuta miofunkcjonalny metody Anity Kittel. Certyfikowany
      terapeuta metody Palin PCI (terapia jąkania wczesnodziecięcego
      Parent-Child-Interaction Therapy), Członek Polskiego Towarzystwa
      Rehabilitacji Głosu.
    </Typography>
  );
}
